import { IBookFromPreviousTableStrategy } from '@aca-new/app/pages/bookings/pages/previous-order-item/shared/interfaces/book-from-previous-table-strategy.interface';
import { AuditsTableStrategyService } from '@aca-new/app/pages/bookings/pages/previous-order-item/shared/services/table-stratetgy/audits-table-strategy.service';
import { FoodCertificationTableStrategyService } from '@aca-new/app/pages/bookings/pages/previous-order-item/shared/services/table-stratetgy/food-certification-table-strategy.service';
import { InspectionTableStrategyService } from '@aca-new/app/pages/bookings/pages/previous-order-item/shared/services/table-stratetgy/inspection-table-strategy.service';
import { LabTestingTableStrategyService } from '@aca-new/app/pages/bookings/pages/previous-order-item/shared/services/table-stratetgy/lab-testing-table-strategy.service';
import { EBusinessSolution } from '@aca-new/app/shared/models/enums/business-solution.enum';
import { Injectable } from '@angular/core';

@Injectable()
export class TableStrategyFactoryService {
  public constructor(
    private readonly _foodCertificationTableStrategyService: FoodCertificationTableStrategyService,
    private readonly _inspectionTableStrategyService: InspectionTableStrategyService,
    private readonly _labTestingTableStrategyService: LabTestingTableStrategyService,
    private readonly _auditsTableStrategyService: AuditsTableStrategyService
  ) {}

  public getTableStrategyService(businessSolution: string): IBookFromPreviousTableStrategy {
    switch (businessSolution) {
      case EBusinessSolution.INSPECTIONS:
        return this._inspectionTableStrategyService;
      case EBusinessSolution.LAB_TESTING:
        return this._labTestingTableStrategyService;
      case EBusinessSolution.AUDITS:
        return this._auditsTableStrategyService;
      case EBusinessSolution.FOOD_CERTIFICATION:
        return this._foodCertificationTableStrategyService;
      default:
        return this._inspectionTableStrategyService;
    }
  }
}
